import React, { FC } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { Link } from '@reach/router';
import { globalTheme } from '@cld/component-theme';
import Tooltip from '@cld/tooltip';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { toDemo } from '../../../../router';
import { getAssetUrl } from '../../../../utils';
import { Text } from './Text';

const Root = styled.div`
  background: ${globalTheme.palette.surface};
`;

const ContentWrapper = styled.div`
  margin: auto;
  padding: calc(${globalTheme.spacing.lg} * 3) 0 calc(${globalTheme.spacing.lg} * 2);
  max-width: calc(${globalTheme.spacing.lg} * 68);
  display: flex;
`;

const ImageLink = styled(Link)`
  margin-left: calc(${globalTheme.spacing.lg} * 8);
`;

export const Embed: FC = () => {
  const { formatMessage } = useIntl();
  const analytics = useAnalytics();

  return (
    <Root>
      <ContentWrapper>
        <Text />
        <Tooltip trigger="hover" title={formatMessage(messages['landing.embedSection.tooltip'])} placement="top">
          <ImageLink to={toDemo()} data-test="embed-section-img-link" onClick={() => analytics('navigate', 'click on code area')}>
            <img src={getAssetUrl('embed-section.svg')} alt="Embed section" />
          </ImageLink>
        </Tooltip>
      </ContentWrapper>
    </Root>
  );
};
